import axios from "axios";
import React, { useEffect, useState } from "react";
import { API } from "../../../api/URL_API";
import { Carousel } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ArrowRight } from "react-bootstrap-icons";

function BannerHome({ idSucursal }) {
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true);

    //Obtener Banners
    useEffect(() => {
        const fetchBanners = async () => {
            try {
                const response = await axios.get(
                    `${API}/api/banners`
                );
                //console.log("🎠 Banners Home:", response.data);
                setBanners(response.data);
            } catch (error) {
                console.error("❌ Error cargando banners:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchBanners();
    }, []);

    return (
        <>
            <section className="banner-wrapper">
                {loading ? (
                    <div className="banner-skeleton">
                        <div className="banner-skeleton-img" />
                    </div>
                ) : banners.length === 0 ? (
                    <div className="text-center py-5 text-muted">
                        No hay banners disponibles
                    </div>
                ) : (
                    <Carousel fade controls indicators interval={5000} pause={false}>
                        {banners.map((banner, index) => (
                            <Carousel.Item key={banner.idBanner}>
                                <Link to={`/${idSucursal}/${banner.link}`}>
                                    <div className="banner-frame">
                                        <div
                                            className="banner-bg"
                                            style={{ backgroundImage: `url(${banner.imageUrl})` }}
                                        />

                                        <img
                                            className="banner-img"
                                            src={banner.imageUrl}
                                            alt="Banner"
                                            loading={index === 0 ? "eager" : "lazy"}
                                        />

                                        {/* 🔥 CTA OVERLAY */}
                                        <div className="banner-overlay">
                                            <div className="banner-cta">
                                                <span className="banner-cta-btn">
                                                    Ver productos
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                )}
            </section>

            {/* 🔽 BOTÓN MINIMALISTA MODERNO */}
            <div className="banner-action-wrapper color-bg-secundary">
                <Link to={`/${idSucursal}/Catalogo`} className="modern-cta-link">
                    <div className="modern-cta-content">
                        <span className="modern-cta-text">Explora más categorías</span>
                        <ArrowRight className="modern-cta-icon" size={22} />
                    </div>
                    <div className="modern-cta-underline"></div>
                </Link>
            </div>
        </>
    );
}

export default BannerHome;